import {mount} from 'svelte';

import {compact} from '@js/modules/utils';

import PlaceShow from '@js/components/place/PlaceShow.svelte';

class PlaceManager {
    _$placeElement = document.getElementById('places-component');

    _initialLocation = null;
    _placeId = null;
    _rideType = null;

    /* Initialization
    ******************** */
    constructor() {
        this._initialLocation = this._$placeElement ? JSON.parse(this._$placeElement.getAttribute('data-location')) : null;
        this._placeId = this._$placeElement?.getAttribute('data-place');
        this._rideType = this._$placeElement?.getAttribute('data-ride-type');
    }

    initialize = () => {
        if (!this._$placeElement) {
            return;
        }

        mount(PlaceShow, {
            target: this._$placeElement,
            props: {
                initialLocation: this._initialLocation,
                searchParams: compact({
                    placeId: this._placeId,
                    rideType: this._rideType
                })
            }
        });
    };
}

export default new PlaceManager();
